import { AxiosResponse } from "axios";
import { API } from "../index";
import {
  MemberInvitation,
  MemberInvitationConfirmPayload,
  MemberInvitationConfirmResponse,
  MemberInviteCreatePayload,
  MemberInvitationStatus,
  MemberPasswordUpdatePayload,
  MemberPasswordUpdateResponse,
  MemberPermissionUpdatePayload,
  MemberPermissionUpdateResponse,
  SiteMemberLookupResponse,
  SiteMemberRegisterPayload,
  SiteMember,
  SiteMemberDeleteResponse,
} from "../types/member";

export const membershipService = {
  getMemberInvitations: async (
    siteId: number,
    params?: {
      status?: MemberInvitationStatus;
    }
  ): Promise<AxiosResponse<MemberInvitation[]>> => {
    const query = params?.status ? `?status=${params.status}` : "";
    return await API.get(`/api/v2/sites/${siteId}/member-invitations/${query}`);
  },

  createMemberInvitation: async (
    siteId: number,
    payload: MemberInviteCreatePayload
  ): Promise<AxiosResponse<MemberInvitation>> => {
    return await API.post(`/api/v2/sites/${siteId}/member-invitations/`, payload);
  },

  resendMemberInvitation: async (
    siteId: number,
    invitationId: number
  ): Promise<AxiosResponse<MemberInvitation>> => {
    return await API.post(`/api/v2/sites/${siteId}/member-invitations/${invitationId}/resend/`, {});
  },

  cancelMemberInvitation: async (
    siteId: number,
    invitationId: number
  ): Promise<AxiosResponse<MemberInvitation>> => {
    return await API.post(`/api/v2/sites/${siteId}/member-invitations/${invitationId}/cancel/`, {});
  },

  updateMemberPermission: async (
    siteId: number,
    userId: number,
    payload: MemberPermissionUpdatePayload
  ): Promise<AxiosResponse<MemberPermissionUpdateResponse>> => {
    return await API.patch(`/api/v2/sites/${siteId}/members/${userId}/permission/`, payload);
  },

  updateMemberPassword: async (
    siteId: number,
    userId: number,
    payload: MemberPasswordUpdatePayload
  ): Promise<AxiosResponse<MemberPasswordUpdateResponse>> => {
    return await API.post(`/api/v2/sites/${siteId}/members/${userId}/password/`, payload);
  },

  getSiteMembers: async (
    siteId: number
  ): Promise<AxiosResponse<SiteMember[]>> => {
    return await API.get(`/api/v2/sites/${siteId}/members/`);
  },

  lookupMemberByPhone: async (
    siteId: number,
    phoneNumber: string
  ): Promise<AxiosResponse<SiteMemberLookupResponse>> => {
    return await API.get(`/api/v2/sites/${siteId}/members/lookup/`, {
      params: { phone_number: phoneNumber },
    });
  },

  registerExistingMember: async (
    siteId: number,
    payload: SiteMemberRegisterPayload
  ): Promise<AxiosResponse<SiteMember>> => {
    return await API.post(`/api/v2/sites/${siteId}/members/`, payload);
  },

  deleteSiteMember: async (
    siteId: number,
    userId: number
  ): Promise<AxiosResponse<SiteMemberDeleteResponse>> => {
    return await API.delete(`/api/v2/sites/${siteId}/members/${userId}/`);
  },

  confirmInvitation: async (
    payload: MemberInvitationConfirmPayload
  ): Promise<AxiosResponse<MemberInvitationConfirmResponse>> => {
    return await API.post(`/api/v2/member-invitation/confirm/`, payload);
  },
};
